<script lang="ts">
  import { page } from "$app/state";
  import Breadcrumb from "$lib/Breadcrumb.svelte";
  import InternalLinking from "$lib/InternalLinking.svelte";
  import Tabs from "$lib/Tabs.svelte";
  import type { InternalLinkingModule } from "$lib/types/shared";
  interface Props {
    children?: import("svelte").Snippet;
    data: {
      module: InternalLinkingModule;
    };
  }

  let { children, data }: Props = $props();

  const subPages = [
    {
      name: "Dagspris",
      href: "/privat/dagens-strompris",
    },
    {
      name: "Timespris",
      href: "/privat/dagens-strompris/timespris",
    },
    {
      name: "Tabell",
      href: "/privat/dagens-strompris/tabell",
    },
  ];

  let isSubPage = $derived(page.url.pathname?.match(/(timespris|tabell)/));
  let pageName = $derived(
    isSubPage?.length ? subPages.find((p) => p.name.toLowerCase() === isSubPage[0])?.name : ""
  );
</script>

<Breadcrumb
  breadcrumbs={[
    { label: "Forside", href: "/" },
    { label: "Spotpris", href: "#" },
  ]}
/>

<h1 class="max-wide:text-2xl max-wide:mt-0 mb-[.5em] mx-edge-x">
  Spotpris{#if isSubPage && pageName}: {pageName}{/if}
</h1>
<p class="mt-0 mx-edge-x">
  Strømprisene i Norge er delt inn i fem ulike prisområder. De kan du filtrere på nedenfor.
</p>
<noscript>
  <p class="mx-edge-x">
    <em>Denne siden krever Javascript – aktiver i nettleserinnstillingene.</em>
  </p>
</noscript>

<div class="wide:mt-8">
  <Tabs tabs={subPages}>
    {@render children?.()}
  </Tabs>
</div>

<div class="max-w-prose my-8 mx-edge-x">
  <p>
    Prisene som oppgis er hentet fra strømbørsen NordPool og viser spotprisene for de ulike
    prisområdene i Norge. Prisene oppgis i øre/kWh. Prisene er inklusiv moms, unntatt prisområde
    Nord-Norge som er fritatt. Ønsker du mer detaljer angående spotpris og ditt forbruk anbefaler vi
    deg om å laste ned vår app.
  </p>
  <a class="button button-primary" href="/app">Les mer om appen og last ned her</a>
</div>

{#if data.module}
  <InternalLinking module={data.module} />
{/if}
